module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("09:45")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Karen is standing in a car park. Exactly how she has got here or how long she has been here, she is not sure. It is only when, fingers trembling, she tries to light a cigarette that she realizes it is raining. The white paper becomes peppered with droplets that expand and turn it soggy. She looks up; grey clouds skid across the sky. She tilts her head right back. Her face is rapidly covered in water. She should be able to feel it, cool and wet on her skin, but she can’t. She opens her mouth to see if she can taste it, but though her mouth fills with raindrops, she can’t. She is shivering, but she can’t sense the cold.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She tries to locate herself. A large sign, white type out of blue, announces:")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Royal Sussex County Hospital")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seems to make some kind of sense. What is she supposed to do now?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Simon is dead.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dead.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even though she repeats the word to herself, even though she has seen him die, right in front of her, it is not real. Even though she has watched as two nurses tried to revive him on a train and some paramedics tried to shock his heart into working – they tried again and again, and in the ambulance too. Even though a doctor confirmed he was dead a few minutes ago and recorded the time of death; it is still not real, not at all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They let her be with Simon in A&E – there were tubes everywhere. Now they are moving him to the mortuary – to the viewing room, apparently, where they’ve suggested she might like to spend some more time with his body. But she wanted a cigarette, first, so somehow she has ended up out here, bewildered, numb.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Numb.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She repeats this word too, aloud this time. She has a weird recollection. Don’t they say that feeling numb is the first stage of grief?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She supposes she ought to do something about the children. What time is it? Where are they? Ah, yes, of course, today they are with the childminder: Tracy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tracy’s number, yes, right – it is on her mobile.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oh dear, it is raining; so it is, of course. She had best move out of the rain; her phone will get wet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Karen sees there is a big glass awning at the entrance to the hospital, a few paces away. There are people beneath it, chatting. She joins them. Briefly, now she is under cover, she is conscious she is drenched. Her fringe is sticking to her forehead in rats’ tails and there are rivulets of cold water running down the back of her neck; even her suede pumps are soaked – how horrible.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She gets the phone out of her Liberty-print shopper – the bag she uses to carry paperwork when she has it, and which today also contains the March issue of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Good Housekeeping")]), _vm._v(", her purse, lipstick and a comb, a bottle of water and her cigarettes. Her mobile, a basic model with a worn leather case, which her children have covered in ghastly sparkly stickers, has Tracy’s number listed in the address book. She is sure there’s a quicker way to find it – speed dial or something – but can’t remember how it works. So she scrolls down the alphabetic list and is just about to press the green button and dial when she stops.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What on earth is she doing? What is she planning to say? ‘Luke, Molly, Daddy’s dead. Come to the hospital and see the body’? They’re five and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("three,")]), _vm._v(" for God’s sake. They won’t understand. She doesn’t understand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jesus. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jesus")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No, what Karen needs is to speak to her friend, her best friend. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("She")]), _vm._v(" will know what to do: she always does. This is one number she knows automatically without having to think. Fingers still shaking, Karen punches in the digits.")]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "height": "46",
      "src": "Images/sp.jpg",
      "width": "103"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Not far from Clapham Junction, the taxi is stuck in traffic. The driver has made excellent time up the M23, wound through the depressing suburban sprawl of Croydon, Norbury and Streatham at an impressive rate despite dozens of sets of lights, but so far it has taken them about twenty minutes to get down St John’s Hill.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna is just beginning to feel twinges of impatience, when there is a vibrating against her hip: her phone. Soon it is ringing increasingly loudly from the depths of her snakeskin bag. She rummages around. Damn – where is it? Finally she feels smooth metal and pulls out a neat, clam-shaped device.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hurriedly she flicks it open, knowing she only has seconds before voicemail clicks in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Hiya!’ she says, happy to see the name that comes up on the screen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Anna?’ checks a voice, thin, plaintive.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, it’s me. That you?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The voice on the other end cracks. ‘Yes.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It sounds as if there is something the matter. ‘Hey, hey,’ says Anna, adopting a gentler tone and leaning into the mouthpiece to make herself heard. ‘What’s happened?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It’s – it’s – Simon.’ The voice – so familiar to Anna – is strangely small.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What about him?’ Anna is confused.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He’s—’ There is a pause. A long pause.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("What?")]), _vm._v("’ Anna is insistent – now she is worried.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He’s…’ Then everything rushes through Anna’s head at once. She has a terrible premonition: she knows what’s coming next, but it can’t be, no, it can’t – then, finally, dreadfully, confirmation; the word is there, out, in the cab, real. ‘…dead.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, my God!’ cries Anna. Thoughts hurtle. What is this – some kind of sick joke?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What is it?’ says Lou, immediately grabbing Anna’s knee.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna shakes her hand, motioning that quiet is called for. ‘What – when –?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Just now – this morning – on the train –’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What? The seven forty-four to Victoria? No!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes.’ The voice is barely audible. ‘How did you know?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But I was on that train!’ exclaims Anna. ‘Christ, I don’t believe it! Oh, oh, Karen—’ Instinctively, she starts to cry; giant tears plop forth before she can stop herself. It is not even sorrow, really; the information hasn’t even sunk in. It is shock. Karen and Simon are her friends. Karen is her "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("best")]), _vm._v(" friend. Still, she has to get the facts straight. ‘But what were you doing on that train? You never normally get that train – that’s the one "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I")]), _vm._v(" get.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, I suppose it must be,’ says Karen. ‘I didn’t think.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Shit.’ All at once Anna realizes this is no joke. It makes sense. ‘You had to sign the mortgage papers today, no?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes,’ says Karen, scarcely above a whisper. ‘We were going up to London together, to the solicitors, before Simon went on to work. It seemed to make sense to do it like that. And then I had some shopping to do. I was going to Hamleys to get a birthday present for Luke.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At this point, the taxi driver interrupts. ‘I’m sorry, love,’ he says, his manner less brusque this time. ‘But we’re here.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What?’ Anna looks out of the window; sees a flower stall, a splash of colours and foliage, and up above it, a large red sign:")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Clapham Junction")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, oh, right.’ She gathers up her bag. ‘Hang on a minute, Karen, hang on, just need to pay for this taxi. Stay there, right there – I’ll be with you in a tick.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It’s OK,’ says Lou. ‘You get out – carry on – I’ll get this, don’t worry. You’re all right, we’ll sort it in a sec.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna nods her head, grateful. ‘Thanks.’ She opens the taxi door and somehow manoeuvres herself from the car onto the pavement, still holding her phone open precariously so as not to lose Karen. Lou pays the driver – luckily she seems to have enough cash – and follows her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You still there?’ Anna checks.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes,’ says Karen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Just a second.’ Despite everything, Anna wants to settle up. She digs deep into her bag for her purse but just as she pulls it out, she drops it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lou retrieves it. ‘I can wait,’ she says, handing it back. ‘Please. You just carry on.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Are you sure?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lou nods and diplomatically steps to one side so as not to be intrusive.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna returns to Karen. ‘Where are you?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘At the hospital,’ says Karen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Which hospital? Haywards Heath?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, Brighton. For some reason they brought us here – I suppose it’s because they have a cardiac ward or something.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, right. So, tell me, what happened, exactly?’ Although she’s heard the story from Lou already, Anna has to hear it again from Karen to make sure the experiences tally and to grasp the fact that it’s real.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘We were sitting on the train, together, this morning, you know, everything was normal, when – I don’t know – we were chatting, we had a coffee each, and – suddenly – he had a heart attack.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What? Just from nowhere?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Well, the funny thing is, he had been complaining of indigestion on the way to the station. But you know Simon, he’s always getting heartburn, he gets so wound up about stuff, and – well, to be honest, I thought it was nothing. Just nerves, about the new house, signing the papers.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna nods, although there’s no way Karen can see her. ‘So, what—’ Anna hesitates, unsure if she’s being insensitive, but ploughs on anyway. There have never been many barriers between herself and Karen. ‘Did it just come on all of a sudden, or what?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yeah. He was right beside me. It all happened in minutes…He was sick, fell forward, knocked over his coffee. Then nurses came running, tried to resuscitate him, and everyone had to get off the train, then there was an ambulance and we were taken to hospital. They took him to A&E…Then I had to talk to the police, and the hospital chaplain – there were so many people. But the doctor said there was nothing anyone could have done.’ Karen’s voice tails off to a whisper again. ‘Apparently he died immediately. Just like that.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna is reeling. She leans against the pillar of the flower stall for support. ‘Er – er…Let me think…Where did you say you were?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘The Royal Sussex.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What, in Kemptown?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, right.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘The children?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘They’re at Tracy’s.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Luke’s not at school?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, it’s half-term in Brighton this week. We took them both there, so we could go on to London.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I see. When are you supposed to be picking them up?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, um…half three.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That’s good – it gives us a bit of time, Anna thinks, her mind whizzing. ‘You told them?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Tracy?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, no, not yet. You were the first person I called.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And where’s Simon?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Um…’ Karen sounds fazed, as if she doesn’t know what Anna means. ‘He’s here, too. At the hospital. They’re moving him to a special room. I’m to go back in a while. I suppose to A&E. Where are you?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Clapham Junction. The station. I got a taxi—’ Anna thinks about explaining that she has just been sitting next to a woman who witnessed Simon’s death, but then decides not to. Now is not the time, and it is not relevant. ‘Look…’ She tries to formulate a plan. ‘I’ll come back. I’ve got a meeting, but someone else can go. It’s not that important, really. I’ll call them. They’ll understand, and if they don’t, well, sod it. So, I dunno…wait there. I’ll be—’ She checks her watch. It’s five to ten. ‘I think the trains go at twelve minutes past the hour. As long as they’re still running the other way, I can be back in Brighton by eleven, and get a taxi, be with you as soon as I can.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Can you really?’ Karen’s voice cracks again. ‘Are you sure you don’t mind?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Mind?’ Anna is incredulous she should even ask. ‘Of course I don’t mind. Where are you going to wait? Are you going to go home?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I don’t know.’ Karen is obviously in no state to make a decision. ‘Later, yes, but I want to be with Simon now…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Of course. I’ll be on the phone again anyway, in a minute. I just want to make sure I get the next train and ring work, so I’m going to go now. OK? I’ll call you again, in a bit.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘OK,’ so quietly. ‘Thanks.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A few seconds later Anna feels a squeeze on her shoulder. It’s Lou. ‘You all right?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, I guess,’ though she’s far from it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Do you want to go for a coffee or something? You’re white as a sheet. I think you ought to sit down.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No. I have to go. That was my friend, Karen. It was her husband on the train. I’ve got to get back and see her. But thanks anyway.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Are you sure? You really look as though you could do with sitting down. There’s a coffee shop right here…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lou is right: Anna has been gazing at the familiar blue logo whilst on the phone without really seeing it. ‘No.’ She is definite. ‘I need to get the next train, I promised.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I understand.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna smiles, weakly, then recalls, ‘Oh, gosh, I owe you fifty quid, don’t I? Or is it more than that? Did we give him a tip?’ She rummages in her purse. ‘Damn! I’ve only got three twenties.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Two’s plenty. Really. You don’t want to leave yourself short or you won’t be able to get a cab at the other end.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, no,’ insists Anna. ‘I’m sure I can change one.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Don’t be silly! Forty is fine.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I hate owing money.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘All right, then, but tell you what: rather than worrying about that now, here, take this.’ Now it’s Lou’s turn to open her wallet: she takes out a functional-looking white business card headed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hammersmith & Fulham Education Services.")]), _vm._v(" ‘Pop it in the post to me at some point. Or better still, give me a call or text me one day when you’re on the train. Well, you know.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yeah, sure,’ says Anna.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I work Mondays to Thursdays. Or give me a ring any time. If you just want to talk.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lou’s expression is so sympathetic Anna doesn’t know what to say. She mutters ‘Thanks’, but it seems quite inadequate.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It’s nothing.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, well, still, I appreciate it.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Really, don’t give it any thought. And please, when it’s appropriate – if it ever is – tell your friend, I really am very sorry.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Um, yes, sure, I will,’ says Anna.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-447aa42f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429938327_ch03.vue
// module id = 75
// module chunks = 0